import { useEffect }              from 'react';
import { store }                  from 'index';
import { groupUrl }               from 'utils/constants'
import { GET_GROUP_CONTENT_SAGA } from 'actions';
import { SET_GET_CONTENT_ONCE }   from 'actions/contentActions';

const useGetGroupContent = () => {

    const state          = store.getState();
    const getContentOnce = state.content.getContentOnce;

    useEffect(() => {
        if (typeof groupUrl === 'string' && !getContentOnce) {

            store.dispatch(SET_GET_CONTENT_ONCE());
            store.dispatch(GET_GROUP_CONTENT_SAGA(groupUrl));
        }
    },[getContentOnce])

}
export default useGetGroupContent;

